import { LegalLinks } from '@/components/common/LegalLinks'
import { useCurrentOrganization } from '@/features/organization/hooks/useCurrentOrganization'

/**
 * The organization's own footer text and legal links. Takes no space until the
 * organization has set some.
 */
export function Footer(): React.ReactElement | null {
  const { data: organization } = useCurrentOrganization()
  const { footerText, termsUrl, privacyUrl } = organization?.branding ?? {}

  if (!footerText && !termsUrl && !privacyUrl) return null

  return (
    <footer className="flex flex-col items-center gap-x-4 gap-y-1 px-4 py-3 text-center text-[11px] text-gray-500 sm:flex-row sm:justify-center sm:px-5 lg:px-6 dark:text-gray-400">
      {footerText ? <span className="min-w-0 break-words">{footerText}</span> : null}
      <span className="flex shrink-0 items-center gap-3">
        <LegalLinks termsUrl={termsUrl} privacyUrl={privacyUrl} />
      </span>
    </footer>
  )
}
